// @flow
import {connect} from 'react-redux';
import Home from '../components/Home';
import type {RootState} from '../../index';

import type {Dispatch} from 'redux';
import {bindActionCreators} from 'redux';

import {actions as ProductsActions} from '../../products/duck';
import {actions as OrdersActions} from '../../orders/duck';
import {actions as DashboardActions} from '../../dashboard/duck';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    resellerInformation: state.ui.resellerInformation,
    isFetchingResellerInformation: state.ui.isFetchingResellerInformation,
    productsCount: state.products.pagination
      ? state.products.pagination.total
      : undefined,
    ordersCount: state.orders.ordersCount,
    categoriesCount: state.categories.categories
      ? state.categories.categories.length
      : undefined,
    socialMedia: state.information.socialMedia,
    pageViews: state.dashboard.pageViews,
    productData: state.dashboard.productData,
    orderData: state.dashboard.orderData,
    productCategoryData: state.dashboard.productCategoryData,
    firstStepsCompleted: state.dashboard.firstStepsCompleted,
    isCheckingIfFirstStepsCompleted:
      state.dashboard.isCheckingIfFirstStepsCompleted,
    domainExpositionData: state.dashboard.domainExpositionData,
    points: state.referral.availablePoints,
    subscription: state.tiersList.currentSubscription,
    subscriptionSetting: state.accountConfig.subscriptionSetting,
    completedConfig: state.dashboard.completedConfig,
    dueInformation: state.tiersList.dueInformation,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ProductsActions,
        ...OrdersActions,
        ...DashboardActions,
      },
      dispatch
    )
)(Home);
